import React from "react";
import {img} from "@/utils/pluginImg.js";

// Green "Exclusive Airport Pickup Perks" bar. The `.pc-more-bar` styles are scoped
// under `.prebook-compare`, so the parent must supply that wrapper class (the booking
// flow's `.hopn-modal-footer.prebook-compare` footer, or a plain `.prebook-compare`
// wrapper on the edit page).
// `compact` is the booking-received variant: the title sits on one line beside the
// logo and the trailing control is a chevron rather than a "More →" link.
export default function ExclusivePerksBar({onClick, compact = false}) {
    if (compact) {
        return (
            <button type="button" className="pc-more-bar" onClick={onClick}>
                <span className="pc-more-left">
                    <img src={img("logo-latest.svg")} alt="hopn"/>
                    Exclusive Airport Pickup Perks
                </span>
                <span className="pc-more-caret"><img src={img("arrow-down.svg")} alt=""/></span>
            </button>
        );
    }

    return (
        <button type="button" className="pc-more-bar" onClick={onClick}>
            <span className="pc-more-left">
                <img src={img("logo-latest.svg")} alt="hopn"/>
            </span>
            <span className="pc-more-title">Exclusive Airport Pickup Perks</span>
            <span className="pc-more-link"><img src={img("arrow-down.svg")} alt=""/></span>
        </button>
    );
}
